<template>
	<v-container fluid v-if="selectedPlace && selectedService">
		<v-row>
			<v-col cols="12" sm="6" md="4" class="my-2">
				<v-menu v-model="menu" :close-on-content-click="false" max-width="290">
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							solo
							class="my-2"
							clearable
							dense
							outlined
							filled
							label="Seleccione un mes"
							readonly
							v-bind="attrs"
							v-on="on"
							@click:clear="month = null"
							hide-details
							:value="dateFormatted"
						></v-text-field>
					</template>
					<v-date-picker
						v-model="month"
						@change="menu = false"
						no-title
						type="month"
						locale="es"
					></v-date-picker>
				</v-menu>
				<v-text-field
					solo
					class="my-2"
					dense
					hide-details
					label="Nombres o fechas"
					outlined
					filled
					append-icon="mdi-magnify"
					single-line
					v-model="search"
				></v-text-field>
				<v-checkbox
					class="my-2"
					dense
					hide-details
					label="Publicar asistencia"
					outlined
					filled
					single-line
					v-model="checkPublicAssistance"
				>
				</v-checkbox>
				<v-text-field
					v-if="checkPublicAssistance"
					solo
					class="my-2"
					dense
					label="Contraseña"
					type="text"
					outlined
					filled
					autocomplete="new-password"
					append-icon="mdi-magnify"
					single-line
					v-model="password"
				></v-text-field>
				<v-btn name="submitPublicAssistance" @click="onSubmitPublicAssistance">
					Actualizar
				</v-btn>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" class="overflow-x-auto assitence-history">
				<v-data-table
					mobile-breakpoint="300"
					:headers="headers"
					:items="items"
					item-key="_id"
					:items-per-page="itemsPerPage"
					class="elevation-1 backgroundTransparent"
					no-data-text="Sin registros de asistencia"
					:footer-props="{
						'items-per-page-text': 'Registros por página',
					}"
				>
					<!-- fullname/nombre -->
					<template v-slot:[`item.fullName`]="{ item }">
						<div class="row-td-block text-capitalize">
							{{ item.person.firstName }} {{ item.person.lastName }}
						</div>
					</template>
					<!-- date/fecha -->
					<template v-slot:[`item.date`]="{ item }">
						<div class="row-td-block ">
							{{ dateTime(item) }}
						</div>
					</template>
					<!-- in/Ingreso -->
					<template v-slot:[`item.in`]="{ item }">
						<div class="row-td-block " v-if="!item.worked">
							{{ formatDate(item.in) }}
						</div>
						<div class="row-td-block " v-else>-</div>
					</template>
					<!-- in/temperature -->
					<template v-slot:[`item.temperature`]="{ item }">
						<div class="row-td-block " v-if="item.temperature">
							{{ item.temperature }}
						</div>
						<div class="row-td-block " v-else>S/R</div>
					</template>
					<template v-slot:[`item.group`]="{ item }">
						<div class="row-td-block " v-if="item.group">{{ item.group }}</div>
						<div class="row-td-block " v-else>S/R</div>
					</template>
					<!-- image/foto -->
					<template v-slot:[`item.image`]="{ item }">
						<div v-if="item.image" class="row-td-block ">
							<a class="text-capitalize" :href="item.image" target="_blank">
								Ver foto
							</a>
						</div>
						<div class="row-td-block " v-else>Sin foto</div>
					</template>
					<!-- out/salida -->
					<template v-slot:[`item.out`]="{ item }">
						<div class="row-td-block " v-if="!item.worked">
							{{ formatDate(item.out) }}
						</div>
						<div class="row-td-block " v-else>-</div>
					</template>
					<!-- extra/horas extra -->
					<template v-slot:[`item.extra`]="{ item }">
						<div class="row-td-block " v-if="!item.worked">{{ item.extra }}</div>
						<div class="row-td-block " v-else>-</div>
					</template>
					<!-- delay/horas de retraso -->
					<template v-slot:[`item.delay`]="{ item }">
						<div class="row-td-block " v-if="!item.worked">{{ item.delay }}</div>
					</template>
					<!-- durations/duracion entre la entrada y salida -->
					<template v-slot:[`item.durations`]="{ item }">
						<div class="row-td-block " v-if="!item.worked">
							{{ durations(item.in, item.out) }}
						</div>
					</template>
					<!-- total earned/total ganado durante ese dia -->
					<template v-slot:[`item.earned`]="{ item }">
						<template v-if="item.earned">
							<div class="row-td-block ">{{ item.earned.toFixed(2) }}</div>
							<div class="row-td-block success--text">$</div>
						</template>
						<div class="row-td-block" v-else>-</div>
					</template>
					<!-- ubications -->
					<template v-slot:[`item.actions`]="{ item }">
						<div class="row-td-block" v-if="item.worked">Sin ubicaciones</div>
						<div class="row-td-block" v-else>
							<v-btn
								class="m-0 mr-2"
								color="info"
								x-small
								@click="setMap(item.checkIn)"
							>
								<v-icon small left>mdi-map-marker-check</v-icon>
								<div class="row-td-block" v-if="!isMobile">Ingreso</div>
							</v-btn>
							<v-btn
								color="info"
								x-small
								class="m-0 mr-2"
								:disabled="formatDate(item.out) == '-'"
								@click="setMap(item.checkOut)"
							>
								<v-icon small left>mdi-map-marker-check</v-icon>
								<div class="row-td-block" v-if="!isMobile">Salida</div>
							</v-btn>
						</div>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
		<v-dialog v-model="dialog" width="500" @click:outside="close">
			<v-sheet>
				<v-toolbar dense>
					<span class="title">Ubicación</span>
					<v-spacer></v-spacer>
					<v-btn icon @click="close">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>
				<GeoAssistance v-show="position" :position="position" />
			</v-sheet>
		</v-dialog>
	</v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Moment from 'moment';
import { extendMoment } from 'moment-range';

let moment = extendMoment(Moment);
export default {
	components: {
		GeoAssistance: () => import('@/components/lodgings/GeoAssistance'),
	},
	data() {
		return {
			idMap: '',
			headers: [
				{ text: 'Fecha', value: 'date', sortable: true },
				{ text: 'Grupo/Periodo', value: 'group', sortable: true },
				{ text: 'Nombre', value: 'fullName', align: 'start', sortable: false },
				{ text: 'Ingreso', value: 'in', sortable: true },
				{ text: 'Temp.', value: 'temperature', sortable: true },
				{ text: 'Foto', value: 'image', sortable: false },
				{ text: 'Salida', value: 'out', sortable: false },
				{ text: 'Horas extra', value: 'extra', sortable: false },
				{ text: 'Horas faltantes', value: 'delay', sortable: false },
				{ text: 'Duración', value: 'durations', sortable: false },
				{ text: 'Ganado', value: 'earned', sortable: false },
				{ text: 'Ubicación', value: 'actions', align: 'end', sortable: false },
			],
			dialog: false,
			position: null,
			search: '',
			itemsPerPage: 30,
			menu: false,
			month: moment()
				.date(1)
				.format('YYYY-MM'),
			checkPublicAssistance: undefined,
			password: '',
		};
	},
	computed: {
		items() {
			let endDate = moment(this.month);
			let histories = [];
			this.lodgings.forEach(lod => {
				if (lod.histories.length)
					lod.histories.map(history => {
						const historyDate = moment(history.in);
						if (historyDate.isSame(endDate, 'month')) {
							histories.push({
								...history,
								person: this.getPerson(lod.person),
								place: lod.place.name,
								room: lod.room,
								group: lod.group,
							});
						}
					});
			});
			histories = histories.sort((a, b) => {
				const da = new Date(a.in).getTime();
				const db = new Date(b.in).getTime();
				return db < da ? -1 : db > da ? 1 : 0;
			});
			if (this.search) {
				const personAssitenceFilter = histories.filter(item => {
					let date = moment(item.in).format('DD-MM-YYYY');
					return (
						item.person.firstName.toLowerCase().indexOf(this.search.toLowerCase()) >
							-1 ||
						item.person.lastName.toLowerCase().indexOf(this.search.toLowerCase()) >
							-1 ||
						date.toLowerCase().indexOf(this.search.toLowerCase()) > -1
					);
				});
				return personAssitenceFilter;
			}
			return histories;
		},
		dateFormatted() {
			return this.month ? moment(this.month).format('MMMM YYYY') : '';
		},
		...mapGetters({
			selectedPlace: 'Lodging/selectedPlace',
			selectedService: 'Lodging/selectedService',
			lodgings: 'Lodging/lodgings',
			persons: 'Person/persons',
			profile: 'User/profile',
		}),
	},
	mounted() {
		this.findPublicPlace();
	},
	methods: {
		findPublicPlace() {
			const { publicAssistance } = this.profile;
			let foundPlace;
			if (this.selectedPlace) {
				foundPlace = publicAssistance.find(
					place => place.idPlace === this.selectedPlace._id
				);
				if (foundPlace) {
					this.password = foundPlace.password;
					this.checkPublicAssistance = true;
				}
			}
		},
		durations(start, end) {
			if (end) {
				const diff = moment(end).diff(moment(start));
				return moment.utc(diff).format('HH:mm:ss');
			}
			return '-';
		},
		dateTime(item) {
			return moment(item.in).format('DD-MM-YYYY');
		},
		formatDate(date) {
			if (date) return moment(date).format('LT');
			else return '-';
		},
		close() {
			this.position = null;
			this.dialog = false;
		},
		setMap(position) {
			this.position = { lat: position[0], lng: position[1] };
			this.dialog = true;
		},
		getPerson(id) {
			return this.persons.find(person => person._id == id);
		},
		async onSubmitPublicAssistance() {
			const user = this.profile;
			const place = this.selectedPlace;
			await this.updatePublicAssistance({
				user,
				place,
				password: this.password,
				check: this.checkPublicAssistance,
			});
			this.findPublicPlace();
		},
		...mapActions({
			updatePublicAssistance: 'User/updatePublicAssistance',
		}),
	},
};
</script>

<style lang="scss">
.assitence-history {
	th {
		min-width: 90px !important;
	}
	table {
		font-size: 12px;
	}
	tbody td {
		padding-right: 10px;
		padding-left: 10px;
		height: 30px;
	}

	tbody tr:nth-child(odd) {
		background-color: #3e419a24;
	}
}
.row-td-block {
	width: max-content;
}
</style>
